import type { ApexOptions } from 'apexcharts'
import { ChartColors } from './chart-colors'
import { localeNumberFormatter } from './chart-formatters'
import { createStandardTooltip } from './chart-tooltip'
import { getBaseBarChartOptions } from './bar-chart.config'

export interface HorizontalBarChartConfig {
  categories: string[]
  seriesName: string
  data: number[]
  color?: string
  valueFormatter?: (v: number) => string
}

export const buildHorizontalBarChartOptions = (config: HorizontalBarChartConfig): ApexOptions => {
  const { categories, seriesName, data, color = ChartColors.blue, valueFormatter = localeNumberFormatter } = config

  const baseOptions = getBaseBarChartOptions()

  return {
    ...baseOptions,
    series: [{ name: seriesName, data, color, type: 'bar' as const }],
    plotOptions: {
      bar: {
        ...(baseOptions.plotOptions?.bar || {}),
        horizontal: true,
        barHeight: '60%'
      }
    },
    // Horizontal bars: x is the value axis, y holds the category labels
    xaxis: {
      ...baseOptions.xaxis,
      categories,
      labels: {
        ...(baseOptions.xaxis as ApexXAxis).labels,
        // Apex passes x-axis label values as strings
        formatter: (value: string) => valueFormatter(Number(value))
      }
    },
    grid: {
      ...baseOptions.grid,
      xaxis: { lines: { show: true } },
      yaxis: { lines: { show: false } }
    },
    tooltip: {
      ...baseOptions.tooltip,
      custom: createStandardTooltip({ valueFormatter })
    }
  }
}
